import React from 'react';
import LoanDetailPage from '../../payroll/LoanDetailPage';

const WholesaleLoanDetailPage = () => {
  return <LoanDetailPage module="wholesale" />;
};

export default WholesaleLoanDetailPage;
